import React from 'react';
import AutoSizeTitle from '../../components/autoSizeTitle/AutoSizeTitle';
import IndividualInformHeader from '../../components/individualInformHeader/individualInformHeader';

const PageIntroPredictiveSelfcare = ({ selectedEvaluation, individualResult, orgLogo, pageNumber }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    return (
        <>
            <div className="pdf-page internal-page">
                <div className="internal-page-content" style={backgroundStyle}>
                    <AutoSizeTitle text={selectedEvaluation?.evl_title} />

                    <div className="internal-page-info internal-page-info-individual">
                        <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />

                        <div className="selfcare-dim-title">Análisis Predictivo — Matrices 2×2</div>

                        <div style={{ fontSize: '0.82em', lineHeight: 1.6, color: '#333' }}>
                            <p>
                                Las siguientes páginas presentan un análisis predictivo basado en el cruce de dos dimensiones del IASH
                                en una matriz 2×2. Cada cruce evalúa cómo la combinación de dos factores específicos puede generar
                                condiciones de mayor o menor riesgo para la seguridad operativa.
                            </p>

                            <p style={{ marginTop: 12 }}>
                                El modelo analiza cinco cruces clave seleccionados por su capacidad predictiva sobre errores humanos
                                y accidentalidad laboral:
                            </p>

                            <ul style={{ paddingLeft: 20, marginTop: 8 }}>
                                <li><strong>Matriz 1:</strong> Manejo emocional × Bienestar físico — Agotamiento dual.</li>
                                <li><strong>Matriz 2:</strong> Disciplina × Comunicación — Riesgo silencioso.</li>
                                <li><strong>Matriz 3:</strong> Conciencia × Propósito — Rutinización.</li>
                                <li><strong>Matriz 4:</strong> Bienestar físico × Disciplina — Fatiga más atajos.</li>
                                <li><strong>Matriz 5:</strong> Comunicación × Responsabilidad — Aislamiento operativo.</li>
                            </ul>

                            <p style={{ marginTop: 12 }}>
                                Cada matriz ubica al operario en una de cuatro zonas según el resultado de ambas dimensiones:
                            </p>

                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 10 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    <span style={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#1E8449', display: 'inline-block' }} />
                                    <span><strong>Protectora:</strong> ambas dimensiones en rango seguro.</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    <span style={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#FDD835', display: 'inline-block' }} />
                                    <span><strong>Mixta:</strong> una dimensión vulnerable, la otra estable.</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    <span style={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#E67E22', display: 'inline-block' }} />
                                    <span><strong>Mixta elevada:</strong> ambas dimensiones requieren atención.</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    <span style={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#C0392B', display: 'inline-block' }} />
                                    <span><strong>Crítica:</strong> alta exposición combinada, intervención inmediata.</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="internal-page-number">{pageNumber}</div>
                </div>
            </div>

            <div className="pdf-page internal-page">
                <div className="internal-page-content" style={backgroundStyle}>
                    <AutoSizeTitle text={selectedEvaluation?.evl_title} />

                    <div className="internal-page-info internal-page-info-individual">
                        <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />

                        <div className="selfcare-dim-title">Cómo leer las matrices predictivas</div>

                        <div style={{ fontSize: '0.82em', lineHeight: 1.6, color: '#333' }}>
                            <p>
                                Cada matriz cruza dos dimensiones del Índice IASH para identificar combinaciones que elevan la
                                probabilidad de error humano. La posición en la matriz no es un diagnóstico, sino una señal
                                que indica dónde enfocar la atención preventiva.
                            </p>

                            <p style={{ marginTop: 12 }}>
                                <strong>Eje horizontal (X):</strong> representa la primera dimensión del cruce. A mayor puntaje, mayor condición protectora.
                            </p>
                            <p style={{ marginTop: 4 }}>
                                <strong>Eje vertical (Y):</strong> representa la segunda dimensión. El mismo principio aplica.
                            </p>
                            <p style={{ marginTop: 4 }}>
                                <strong>Punto de ubicación:</strong> muestra dónde se encuentra el resultado individual dentro de la matriz.
                            </p>

                            <p style={{ marginTop: 12 }}>
                                Las matrices que resulten en zona no protectora generarán un plan de acción predictivo con
                                recomendaciones específicas para operario, supervisor y sistema/área, que se detallan en la sección
                                de Recomendaciones al final del informe.
                            </p>

                            <p style={{ marginTop: 12 }}>
                                <strong>Importante:</strong> los resultados reflejan la autopercepción en el momento de la evaluación.
                                Las condiciones pueden cambiar con el tiempo, por lo que se recomienda realizar seguimiento periódico
                                y complementar con observación directa en campo.
                            </p>
                        </div>
                    </div>

                    <div className="internal-page-number">{pageNumber + 1}</div>
                </div>
            </div>
        </>
    );
};

export default PageIntroPredictiveSelfcare;
